define 'controller/ColorTileController', ['jquery'], ($) ->
  class ColorTileController

    constructor: (@$el) ->
      @_colorTiles()
      @_colorTilesSimilarArticles()
      @_colorTilesGeneralSlider()
      @_hideBrokenColorImages()
      @_showColorCount()

    _colorTiles: ->
      self = @
      @$el.find('[data-controller-element=color-patch]').on 'mouseover', ->
        $this = $(this)
        if !$this.closest('.article__color').hasClass('active')
          $article = $this.closest('[data-controller-element=article]')
          $articleImg = $article.find('[data-controller-element=article-picture-wrapper] img')

          mainImgSrcset = $this.data('main-img')
          if mainImgSrcset && mainImgSrcset != ''
            $articleImg.attr('srcset', mainImgSrcset)
            $articleImg.data('main-img', mainImgSrcset)
            hoverImgSrcset = $this.data('hover-img')
            if hoverImgSrcset
              $articleImg.data('hover-img', hoverImgSrcset)
            else
              $articleImg.data('hover-img', '')
          else
            $articleImg.data('hover-img', '')
            $articleImg.removeAttr('srcset')

          $articleImg.attr('src', $this.data('img-url'))
          self._setArticleDetails($this, $article)

    _setArticleDetails: ($el, $article) ->
      articlenumber = $el.data('articlenumber')
      detailsUrl = $el.data('href')
      $article.data('articlenumber', articlenumber)
      $article.find('[data-controller-element=article-link]').attr('href', detailsUrl)

      $article.find('.article__color.active').removeClass('active')
      $el.closest('.article__color').addClass('active')

    _colorTilesSimilarArticles: ->
      $('.js_colorpatch_sa').mouseover ->
        image = $(this).closest('.product__similar-items__item').find('.product__similar-items__picture a img')
        image.attr('src', $(this).data('picture'))
        detailsUrl = $(this).data('detailsUrl')
        $(this).closest('.product__similar-items__item').find('.product__similar-items__name > a').attr('href', detailsUrl)
        $(this).closest('.product__similar-items__item').find('.product__similar-items__picture > a').attr('href', detailsUrl)

    _colorTilesGeneralSlider: ->
      $('.js_colorpatch_gs').mouseover ->
        image = $(this).closest('.general-slider__product').find('.general-slider__product__picture a img')
        image.attr('src', $(this).data('picture'))
        detailsUrl = $(this).data('detailsUrl')
        $(this).closest('.general-slider__product').find('.general-slider__product__name > a').attr('href', detailsUrl)
        $(this).closest('.general-slider__product').find('.general-slider__product__picture > a').attr('href', detailsUrl)

    _hideBrokenColorImages: ->
      $('.category .article__color img').on 'error', (e) ->
        $(@).hide()
        return

    _showColorCount: ->
      $('.article__colors').each (index) ->
        count = $(this).data('color-count')
        displayColorCountDisplaySmall = count - 3
        displayColorCountDisplayLarge = count - 6
        if displayColorCountDisplaySmall >= 1
          $(this).find('.article__colors__count .three-color-display').html('+' + displayColorCountDisplaySmall)
        if displayColorCountDisplayLarge >= 1
          $(this).find('.article__colors__count .six-color-display').html('+' + displayColorCountDisplayLarge)
        
      return      

    destroy: ->
      @$el.off()